<template>
	<div class="header-area">
		<b-container class="bv-example-row between_layout">
			<div style="margin: 10px 0;">
				<router-link to="/">
					<img class="logo-img" src="../assets/imgs/logo-img.png" />
					<img class="logo-text" style="margin-left: 10px;" src="../assets/imgs/logo-text.png" />
				</router-link>
			</div>
			<div class="end_layout" v-if="!userInfo">
				<router-link to="/purchase">
					<el-button type="danger" class="hidden-xs" size="small" round icon="el-icon-notebook-1">苏学码购买</el-button>
				</router-link>
				<router-link to="/login">
					<el-button class="top-btn" type="text" icon="el-icon-user">登录</el-button>
				</router-link>
				<router-link to="/register">
					<el-button class="top-btn" type="text" icon="el-icon-postcard">注册</el-button>
				</router-link>				
			</div>
			<div class="end_layout" v-else>
				<div class="visible-xs-block">
					<i @click="drawer=true" style="font-size: 34px;color: #fff;" class="el-icon-s-unfold"></i>
				</div>				
				<router-link to="/profile?type=7">
					<el-button class="top-btn hidden-xs" type="text" icon="el-icon-s-tools">设置</el-button>
				</router-link>
				<router-link to="/purchase">
					<el-button class="top-btn hidden-xs" type="text" icon="el-icon-notebook-1">苏学码购买</el-button>
				</router-link>
				<router-link to="/profile?type=6">
					<el-button class="top-btn hidden-xs" type="text" icon="el-icon-document">使用说明</el-button>
				</router-link>
				<router-link to="/profile?type=7">
					<el-button class="top-btn hidden-xs" type="text"
						icon="el-icon-user-solid">欢迎你，{{userInfo.nickName}}</el-button>
				</router-link>
				<div class="logout hidden-xs" @click="logout">
					退出登录
				</div>				
			</div>			
		</b-container>
		<el-drawer size="60%" title="菜单" :visible.sync="drawer" direction="rtl">
			<div style="margin: 0 15px;box-sizing: border-box;">
				<div id="left" class="widget m-0 widget-categories col-md-3 col-xs-12">
					<ul>
						<li v-for="(item,index) in softwareList" :key="index" @click="switchTab(item)">
							<div href="" :class="item.id==id1?'active':''" class="link">
								<span>{{item.name}}</span><span>></span>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</el-drawer>
	</div>
</template>
<script>
	import {
		getInfo
	} from "@/api/login";
	import {
		getToken,
		removeToken
	} from '@/utils/auth'
	import Utils from '@/utils/callUtils';
	export default {
		name: "Header",
		data() {
			return {
				userInfo: null,
				drawer: false,
				id1: 100,
				softwareList: [{
						id: 7,
						path: '/certificate',
						name: '个人资料'
					},
					{
						id: 1,
						path: '/certificate',
						name: '我的证书'
					},
					{
						id: 2,
						path: '/order',
						name: '我的订单'
					}, {
						id: 3,
						path: '/archives',
						name: '档案管理'
					}, {
						id: 4,
						path: '/exam',
						name: '我的考试'
					}, {
						id: 5,
						path: '/purchase',
						name: '苏学码购买'
					},
					{
						id: 6,
						path: '/feedback',
						name: '使用说明'
					},
					{
						id: 8,
						path: null,
						name: '退出登录'
					}
				]
			};
		},
		watch: {
			$route: {
				immediate: true,
				handler(to, from) {
					if (getToken()) {
						getInfo().then(res => {
							this.userInfo = res.data.user
						})
					}
				}
			}
		},
		methods: {
			//退出登录
			logout() {
				this.$confirm('确定注销并退出系统吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					removeToken()
					this.$router.push({
						path: "/login"
					})
				}).catch(() => {});
			},
			/** 切换tab */
			switchTab(item) {
				this.id1 = item.id
				if (item.id == 8) {
					this.logout()
				} else if (this.$route.path != '/profile') {
					this.$router.push({
						path: "/profile?type=" + item.id
					})
				} else {
					Utils.$emit('changeDrawer', item);
				}
				this.drawer = false
			}
		}
	};
</script>
<style scoped>
	.header-area {
		background: -webkit-gradient(linear, left top, right top, from(#7e3afb), to(#29b9f5));
		box-shadow: 0px 5px 5px 0px rgb(0 0 0 / 4%);
		z-index: 999;
	}

	.top-btn {
		color: #fff;
		font-size: 16px;
		margin-left: 18px;
	}

	.logout {
		background-color: #F34343;
		padding: 6px 20px;
		border-radius: 50px;
		margin-left: 20px;
		color: #fff;
		cursor: pointer;
	}

	@media screen and (max-width: 997px) {
		.logo-img {
			width: 50px !important;
			height: 50px !important;
		}

		.logo-text {
			width: 120px !important;
			height: 40px !important;
		}

		.top-btn {
			font-size: 14px !important;
			margin-left: 12px !important;
		}
	}

	.logo-img {
		width: 80px;
		height: 80px;
	}

	.logo-text {
		width: 280px;
		height: 70px;
	}

	.widget.widget-categories {
		background-color: white;
		padding: 0px;
		border-radius: 5px;
	}

	.widget.widget-categories h5.widtitle {
		font-size: 22px;
		line-height: 1.45;
		color: #051c35;
		font-weight: 600;
		padding-bottom: 24px;
	}

	.widget.widget-categories ul>li .link {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		border: 2px solid #f7f7f7;
		background-color: rgba(247, 247, 247, 0);
		height: 54px;
		line-height: 3.6;
		padding: 0px 20px 0px;
		margin-bottom: 15px;
		-webkit-transition: 0.5s;
		transition: 0.5s;
		position: relative;
	}

	.widget.widget-categories ul>li .link:after {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 0;
		content: '';
		background: rgba(255, 255, 255, 0);
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	.widget.widget-categories ul>li .link span {
		z-index: 1;
		font-size: 15px;
		line-height: 1.66;
		color: #6f7987;
		-webkit-transition: 0.4s;
		transition: 0.4s;
	}

	.widget.widget-categories ul>li .link:hover span {
		color: #fff;
	}

	.widget.widget-categories ul>li .link:hover:after {
		width: 100%;
		background: #547af8;
	}

	.widget.widget-categories ul>li .link.active span {
		color: #fff;
	}

	.widget.widget-categories ul>li .link.active:after {
		width: 100%;
		background: #547af8;
	}
</style>